module.exports = __webpack_public_path__ + "img/d13-min.a641a3a1.png";